import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoginFooter, LoginNavbar } from '@cfp/shared/ui/login';

@Component({
  selector: 'cfp-self-onboarding-layout',
  templateUrl: './self-onboarding-layout.html',
  //styleUrls: ['./self-onboarding-layout.scss'],
  imports: [LoginNavbar, LoginFooter],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelfOnboardingLayout {
  constructor() {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }
}
